import { isSameDay } from 'date-fns'

export function getHasViewingFormSlotPickerDay({ days, value }) {
  return days.some(day => isSameDay(day, value))
}
